import { StyleSheet, css } from 'aphrodite'
import type React from 'react'
import { useNavigate } from 'react-router-dom'

interface BackButtonProps {
  backUrl?: string
  className?: string
  onBackClick?: () => void
}

const BackButton: React.FC<BackButtonProps> = ({
  backUrl,
  className,
  onBackClick,
}) => {
  const navigate = useNavigate()

  const handleBackClick = () => {
    if (onBackClick) {
      onBackClick()
    }

    if (backUrl) {
      navigate(backUrl)
    } else {
      navigate(-1)
    }
  }

  return (
    <button
      className={`${css(styles.backButton)} ${className}`}
      onClick={handleBackClick}
    >
      <i className="fa-solid fa-arrow-left" />
    </button>
  )
}

const styles = StyleSheet.create({
  backButton: {
    background: 'none',
    border: 'none',
    cursor: 'pointer',
    padding: '6px',
    marginLeft: '-6px',
  },
})

export default BackButton
